import { apiClient } from "@/api";

export const AuthApi = {
  /**
   * Получение информации о текущем пользователе
   */
  async getMe() {
    return apiClient.get("/users/me");
  },

  async login(payload) {
    return apiClient.post("/auth/login", payload);
  },
};
